import React from 'react';
import { useUnit } from 'effector-react';

import { SurveyModal } from 'features/surveyModal';

import { $isModalOpen, closeModal } from './model';

export const Survey = () => {
  const isSurveyModalOpen = useUnit($isModalOpen);

  return <SurveyModal isOpen={isSurveyModalOpen} onClose={closeModal} />;
};
